// import axios from "axios";

import AdditionalInfoApi from '../../apis/api';

export default {
  state: {
    globalContacts: [],
  },

  mutations: {
    SET_GLOBAL_CONTACTS(state, payload) {
      state.globalContacts = payload;
    },
  },

  actions: {
    async fetchGlobalContactsList({ commit, rootState }, type) {
      try {
        const params = {
          type,
          contract_id: rootState.contractId,
          company_id: rootState.companyId,
          company_handle: rootState.companyHandle,
        };
        const res = await AdditionalInfoApi.get(`${rootState.contractId}/${rootState.accessKey}/get_global_contacts`, { params });
        commit('SET_GLOBAL_CONTACTS', res.data);
      } catch (e) {
        commit('setError', { code: e.response.status, message: e.response.data.status, data: e.response.data });
        throw new Error(e);
      }
    },
  },

  getters: {
    getGlobalContactsList(state) {
      return ['New Contact', ...state.globalContacts];
    },
  },
};
